/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let viewModelInfoByIdApiUrl = root.viewModelInfoByIdApiUrl.link;
let modelsForAITaskApiURL = root.modelsForAITaskApiUrl.link;
let countForAITaskApiUrl = root.countForAITaskApiUrl.link;
let mostUsedTrainModelForAiDashApiUrl = root.mostUsedTrainModelForAiDashApiUrl.link;
let modelsUsingApiUrl = root.modelsUsingApiUrl.link;
let trainedModelsAttrApiUrl = root.trainedModelsAttrApiUrl.link;
let trainedModelsAttrForUseApiUrl = root.trainedModelsAttrForUseApiUrl.link;
let searchingTrainedModelsApiUrl = root.searchingTrainedModelsApiUrl.link;
let historiesOfTrainedModelsApiUrl = root.historiesOfTrainedModelsApiUrl.link;
let diseaseCatApiUrl = root.diseaseCatApiUrl.link;
let sharedModulsApiUrl = root.sharedModulsApiUrl.link;
let constantAIModelApiUrl = root.constantAIModelApiUrl.link;
let modelPerformanceParameterListApiUrl = root.modelPerformanceParameterListApiUrl.link;
let recommendedParametersApiUrl = root.recommendedParametersApiUrl.link;
let uploadBatchFileForModelApiUrl = root.uploadBatchFileForModelApiUrl.link;

export default {
  state: {
    getModelsListForAITaskState:{},
    getModelsDetailsByIdState:{},
    getPublicModelsListForAITaskState:{},
    getCountForAiDashboardState:{},
    getMostUsedTrainModelForAiDashState:{},
    getDiseaseForAiDashState:{}
  },
  mutations: {
    getModelsListForAITaskMutation(state, value) {
      Vue.set(state, 'getModelsListForAITaskState', value);
    },
    getModelsDetailsByIdMutation(state, value) {
      Vue.set(state, 'getModelsDetailsByIdState', value);
    },
    getPublicModelsListForAITaskMutation(state, value) {
      Vue.set(state, 'getModelsListForAITaskState', value);
    },
    getCountForAiDashboardMutation(state, value) {
      Vue.set(state, 'getCountForAiDashboardState', value);
    },
    getMostUsedTrainModelForAiDashMutation(state, value) {
     Vue.set(state, 'getMostUsedTrainModelForAiDashState', value);
    },
    getDiseaseForAiDashMutation(state, value) {
     Vue.set(state, 'getDiseaseForAiDashState', value);
    }
  },
  actions: {
    // Model Predict For Batch Data Action
    modelPredictForBatchDataAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(uploadBatchFileForModelApiUrl + '?model_id=' + payload.data.id, payload.data.data).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Post Model Performance Parameter Of The Recommended List Action
    saveRecommenededParametersAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(recommendedParametersApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Model Performance Parameter Of The Recommended List Action
    getRecommendedParametersAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(recommendedParametersApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Model Performance Parameter List Action
    getModelPerformanceParameterListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(modelPerformanceParameterListApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Constant AI Model Function
    postConstantAIModelAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(constantAIModelApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Shared Models For Using Function
   getSharedModelsForAiDashFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(sharedModulsApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Post Shared Models For Using Function
   postSharedModelsForAiDashFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(sharedModulsApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Disease List For AI Function
    getDiseaseListForAiDashFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(diseaseCatApiUrl, payload).then(res => {
                context.commit('getDiseaseForAiDashMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // History Models List For Function
    getHistoryModelsForAiDashFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(historiesOfTrainedModelsApiUrl + '?page_size=10' ).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Search Models For Using Function
    searchModelsForAiDashFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(searchingTrainedModelsApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Attr Of Trained Models For Using Function
    getAttrOfTrainedModelsForDraftFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(trainedModelsAttrForUseApiUrl + payload.id + '/').then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Attr Of Trained Models Function
    getAttrOfTrainedForUseModelsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(trainedModelsAttrApiUrl + payload.id + '/' + '?page_size=15').then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Attr Of Trained Models Function
    getAttrOfTrainedModelsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(trainedModelsAttrApiUrl + payload.id + '/' + '?page_size=14').then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get All Draft Models List Function
   getAllDraftModelsListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(modelsUsingApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Using Models For AI Dashboard Function
   modelsUsingForAiDashFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(modelsUsingApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Most Used Trained Models For AI Task Function
    getMostUsedTrainModelForAiDashFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(mostUsedTrainModelForAiDashApiUrl + '?page_size=5').then(res => {
                context.commit('getMostUsedTrainModelForAiDashMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Count For AI Task Function
    getCountForAiDashboardFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(countForAITaskApiUrl).then(res => {
                context.commit('getCountForAiDashboardMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Create Models For AI Task Function
    createNewModelForAITaskFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(modelsForAITaskApiURL, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Update Model Info by Id Action
    updateModelInfoByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(modelsForAITaskApiURL, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Models List For AI Task Function
    getModelListForAITaskFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(modelsForAITaskApiURL).then(res => {
                context.commit('getModelsListForAITaskMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Public Models List For AI Task Function
    getPublicModelListForAITaskFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(modelsForAITaskApiURL + '?is_public=true').then(res => {
                context.commit('getPublicModelsListForAITaskMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Models Details Function
    getModelDetailsByIDForAIFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(viewModelInfoByIdApiUrl + payload.id + '/').then(res => {
                context.commit('getModelsDetailsByIdMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // update Models Details Function
    updateModelDetailsByIDForAIFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(viewModelInfoByIdApiUrl + payload.data.id + '/', payload.data.data).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
  },
  getters: {
    getModelsListForAITaskGetters : state => state.getModelsListForAITaskState,
    getModelsDetailsByIdGetters : state => state.getModelsDetailsByIdState,
    getPublicModelsListForAITaskGetters : state => state.getPublicModelsListForAITaskState,
    getCountForAiDashboardGetters : state => state.getCountForAiDashboardState,
    getMostUsedTrainModelForAiDashGetters : state => state.getMostUsedTrainModelForAiDashState,
    getDiseaseForAiDashGetters : state => state.getDiseaseForAiDashState,
  }
}